import {AfterViewInit, Component, ElementRef, Input, OnChanges, ViewChild} from '@angular/core';
import {TooltipModule} from "@app/tooltip/tooltip.module";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-no-wrap-string-wrapper',
  templateUrl: './no-wrap-string-wrapper.component.html',
  styleUrls: ['./no-wrap-string-wrapper.component.scss'],
  standalone: true,
  imports: [
    TooltipModule,
    NgIf
  ]
})
export class NoWrapStringWrapperComponent implements OnChanges {
  @Input() text: string = '';
  
  isToolTipVisible = false;
  
  @ViewChild('hiddenBlock', {static : true}) hiddenBlock!: ElementRef;
  @ViewChild('visibleBlock', {static : true}) visibleBlock!: ElementRef;
  
  ngOnChanges(): void {
    this.isToolTipVisible = this.hiddenBlock?.nativeElement.offsetWidth > this.visibleBlock?.nativeElement.offsetWidth;
  }

}
